import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { map, Observable } from "rxjs";
import { ClassJaxService } from "src/app/core/services/classjax.service";
import { PlannerLink, PlannerLinkPlanner } from "./planner-link.model";
import { Plan } from "../planner/plan.model";

@Injectable({
  providedIn: "root",
})
export class LearnService {
  private api = inject(ClassJaxService);
  private modalService = inject(NgbModal);
  private router = inject(Router);
  getPlannerLink(plannerLink: string): Observable<PlannerLink> {
    return this.api.getPublic<{ success: boolean; data: PlannerLink }>(
      `/learn/planner-links/${plannerLink}`,
    ).pipe(
      map((response) => response.data),
    );
  }

  getPlanForDateRange$(
    plannerLink: string,
    planner_id: string,
    startDate: string,
    endDate: string,
  ): Observable<Plan[]> {
    return this.api.getPublic<{ success: boolean; data: Plan[] }>(
      `/learn/planner-links/${plannerLink}/plans`,
      {
        planner_id: planner_id,
        start_date: startDate,
        end_date: endDate,
      },
    ).pipe(
      map((response) => response.data),
    );
  }

  /**
   * Get a single plan with planner information for learn context
   * This uses the API endpoint that respects learn permissions
   */
  getLearnPlan$(planId: string): Observable<{plan: Plan, planner: PlannerLinkPlanner & {owner: any}}> {
    return this.api.getPublic<{
      success: boolean;
      data: {plan: Plan, planner: PlannerLinkPlanner & {owner: any}}
    }>(
      `/learn/plans/${planId}`,
    ).pipe(
      map((response) => response.data),
    );
  }

  /**
   * Navigates to view a plan in full-screen route
   */
  viewPlan(planId: string) {
    this.router.navigate(['/learn/plan', planId]);
  }

  /**
   * Opens a modal to view a plan (legacy method - kept for compatibility)
   */
  openPlanModal(_planner: PlannerLinkPlanner, plan: Plan) {
    // For now, redirect to the new route-based view
    this.viewPlan(plan.plan_id);
  }

  openDocumentModal(document: Document) {
    import("./learn-document-modal/learn-document-modal.component").then(
      (m) => {
        const modalRef = this.modalService.open(m.LearnDocumentModalComponent, {
          windowClass: "fullscreen",
          size: "fullscreen",
          fullscreen: true,
          keyboard: true,
          scrollable: true,
        });
        const learnDocumentModal = modalRef
          .componentInstance;
        learnDocumentModal.document$.next(document);
        return modalRef;
      },
    );
  }
}
